import * as React from 'react';
export const IcRefund = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.71 11.29a1 1 0 00-1.42 0l-.22.22a6 6 0 0110.22-3.75 1.004 1.004 0 101.42-1.42 8 8 0 00-13.64 5.31l-.36-.36a1.004 1.004 0 10-1.42 1.42l2 2a1.001 1.001 0 001.42 0l2-2a1 1 0 000-1.42zm14 0l-2-2a1 1 0 00-1.42 0l-2 2a1.005 1.005 0 001.42 1.42l.27-.27A6 6 0 0112 18a5.931 5.931 0 01-4.24-1.76 1.004 1.004 0 10-1.42 1.42A8 8 0 0020 12.39l.31.32a1.002 1.002 0 001.42 0 1 1 0 00-.02-1.42z'
      fill='currentColor'
    />
  </svg>
);
